<template>
  <div class="artical-haibao">
    <!--海报内容-->
    <div class="haibao-wrapper" ref="imageWrapper">
      <template v-show="!posterImageUrl">
        <div class="info">
          <img :src="headUrl" alt class="user-icon" />
          <div class="rg">
            <p class="nicname">{{this.shareInfo.user.nickname}}</p>
            <p class="child-id">今日我在读:</p>
          </div>
        </div>
        <div class="content">
          <p class="article-big-title">{{this.shareInfo.sourceCn}}</p>
          <p class="artcle-title">{{this.shareInfo.title}}</p>
        </div>
        <div class="btm-info">
          <div class="read-record">
            <p class="title">我在《蓝思原版分级阅读》已经</p>
            <div class="read-info">
              <div class="item">
                <p class="des">坚持阅读</p>
                <p>
                  <span class="read-record-num">{{wordCount}}</span>
                  <span class="read-record-per">词</span>
                </p>
              </div>
              <div class="item">
                <p class="des">坚持阅读</p>
                <p>
                  <span class="read-record-num">{{this.shareInfo.user.dayCount}}</span>
                  <span class="read-record-per">天</span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <PublicErCode :qrCode="this.shareInfo.qrCode" />
        <div class="logo-wrapper">
          <img
            class="btm-img"
            src="../../assets/imgs/haibao-btm-log.png"
            alt
            crossorigin="anonymous"
          />
        </div>
      </template>

      <!--海报-->
      <img class="cover-img" :src="posterImageUrl" v-show="posterImageUrl" alt />
    </div>

    <!--分享指引-->
    <div v-show="shareGuide" class="share-guide">
      <div class="share-guide-content">
        <img
          class="share-guide-img"
          src="../../assets/imgs/haibao_longpush.png"
          @click="shareGuide=false"
        />
        <p class="share-guide-text">长按下方海报可发送好友</p>
      </div>
      <div class="share-guide-bg" @click="shareGuide=false"></div>
    </div>
    <!--加载海报loading-->
    <van-loading
      v-show="showLoading"
      :vertical="true"
      size="24px"
      color="#fff"
      class="haibao-loading"
    >正在生成海报...</van-loading>
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
import PublicErCode from "@/components/pulicErCode/PublicErCode";
import { wxConfigWXApi } from "@/lib/wxShare";
import {
  getUserChildUserId,
  getUserfindShareInfo,
  getChildRecordShareInfo
} from "@/api/share";
import html2canvas from "html2canvas";

export default {
  name: "ReadArticleHaibao",

  data() {
    return {
      shareGuide: true, // 分享引导层显示
      shareUrl: "", //分享的url
      articleTitle: "",
      sourceCn: "",
      childInfo: {},
      shareId: "",
      posterImageUrl: "",
      showLoading: false,
      shareInfo: {
        previewContent: "",
        qrCode: "",
        title: "",
        topic: "NEW YORK DAILY NEWS",
        user: {
          createTime: 1560649049000,
          dayCount: 35,
          headImageUrl: "",
          nickname: "alien",
          rewardPoint: 30,
          roleType: 1,
          vipExpireDate: 1625932799999,
          vipStatus: 1,
          wordCount: 0
        }
      }
    };
  },

  computed: {
    headUrl() {
      if (
        this.childInfo.headImageUrl &&
        this.childInfo.headImageUrl.length > 0
      ) {
        if (this.childInfo.headImageUrl.indexOf("oss") > -1) {
          return require("../../assets/imgs/default-avatar.png");
        } else {
          return this.childInfo.headImageUrl;
        }
      } else {
        return "";
      }
    },
    wordCount() {
      
      if (this.shareInfo.user.wordCount <= 10000) {
        return this.shareInfo.user.wordCount;
      } else if (this.shareInfo.user.wordCount <= 100000000) {
        const wordCount = (Number(this.shareInfo.user.wordCount) / 10000).toFixed(1);
        return `${wordCount}万`;
      } else {
        const wordCount = (
          Number(this.shareInfo.user.wordCount) / 100000000
        ).toFixed(1);
        return `${wordCount}亿`;
      }
    }
  },

  components: {
    PublicErCode
  },

  // beforeCreate() {
  //   //配置该海报可以分享
  //   let that = this
  //   wxConfigWXApi(window.location.href, () => {
  //     setTimeout(() => {
  //       that.setupShare()
  //     }, 500)
  //   })
  // },

  // created() {
  //   //文章标题
  //   this.shareId = this.$route.query.shareId;
  //   if (!this.shareId) {
  //     this.shareGuide = true
  //     this.request_getUserChildUserId()
  //     const articleTitle = this.$route.query.articleTitle;
  //     this.articleTitle = articleTitle;
  //     this.request_postShareChildReadRecord()
  //   } else {
  //     this.request_getUserfindShareInfo()
  //   }
  // },

  activated() {
    //文章标题
    // this.shareId = this.$route.query.shareId;
    // if (!this.shareId) {
    console.log("========");

    this.shareGuide = false;
    this.posterImageUrl = "";
    this.showLoading = false;
    this.childInfo = {};

    this.articleTitle = "";
    this.sourceCn = "";
    // this.request_getUserChildUserId();
    this.request_getShareInfo();

    // } else {
    //   this.request_getUserfindShareInfo()
    // }

    // let that = this
    // wxConfigWXApi(window.location.href, () => {
    //   setTimeout(() => {
    //     that.setupShare()
    //   }, 500)
    // })
  },

  methods: {
    creatPoster() {
      var scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop; // 获取页面滚动高度

      let that = this;
      const options = {
        backgroundColor: null,
        useCORS: true,
        allowTaint: false,
        // windowHeight : scrollTop,
        // scale: 2,
        // x: 0,
        // y: window.pageYOffset, // 用网页滚动的高度定位y轴顶点
        // dpi: window.devicePixelRatio * 2,
      };

      html2canvas(this.$refs.imageWrapper, options).then(canvas => {
        var context = canvas.getContext("2d");
        // 【重要】关闭抗锯齿
        context.mozImageSmoothingEnabled = false;
        context.webkitImageSmoothingEnabled = false;
        context.msImageSmoothingEnabled = false;
        context.imageSmoothingEnabled = false;
                //设置context位置，值为相对于视窗的偏移量负值，让图片复位(解决偏移的重点)
      // let rect = this.$refs.imageWrapper.get(0).getBoundingClientRect();//获取元素相对于视察的偏移量

        let dataURL = canvas.toDataURL("image/png");
        this.posterImageUrl = dataURL;
        // setTimeout(() => {
        //   this.showLoading = false
        //   this.shareGuide = true
        // }, 500)

        that.showLoading = false;
        that.shareGuide = true;
      });
    },

    //================net===============
    //获取用户基本信息
    request_getUserChildUserId() {
      console.log("========", this.$store.state.userInfo);

      if (!this.$route.query.userId) {
        console.log(this.$store.state.userInfo);
        this.childInfo = this.$store.state.userInfo;
        // this.$nextTick(() => {
        //   setTimeout(() => {
        //     this.creatPoster();
        //   }, 1000);
        // });
        return;
      }

      this.showLoading = true;
      const userId = this.$route.query.userId;
      getUserChildUserId(userId).then(res => {
        if (res.code == 0) {
          this.childInfo = res.data;
          //绘制海报
          // this.$nextTick(() => {
          //   setTimeout(() => {
          //     this.creatPoster();
          //   }, 1000);
          // });
        } else {
          this.$toast({
            message: res.msg,
            duration: 1000
          });
        }
      });
    },

    //提交分享记录
    request_getShareInfo() {
      this.showLoading = true;
      const articleId = this.$route.query.articleId;
      const childUserId = this.$route.query.userId;
      const shareSource = this.$route.query.shareSource;
      getChildRecordShareInfo({
        childId: childUserId,
        articleId: articleId,
        shareSource: shareSource
      }).then(res => {
        if (res.code == 0) {
          this.shareInfo = res.data;
          this.$nextTick(() => {
            setTimeout(() => {
              this.creatPoster();
            }, 1500);
          });
          console.log("getChildRecordShareInfo = ", res.data);
        } else {
          this.$toast({
            message: res.msg,
            duration: 1000
          });
          this.showLoading = false
        }
      });
    }

    //获取分享信息
    // request_getUserfindShareInfo() {
    //   getUserfindShareInfo(this.shareId).then(res => {
    //     if (res.code == 0) {
    //       this.childInfo = res.data.user;
    //       this.articleTitle = res.data.title;
    //     } else {
    //       this.$toast({
    //         message: res.msg,
    //         duration: 1000
    //       })
    //     }
    //   })
    // },

    //设置分享
    // setupShare() {
    //   let that = this;
    //   wx.showMenuItems({
    //     menuList: [
    //       'menuItem:share:appMessage',
    //       'menuItem:share:timeline'
    //     ]
    //   });
    //
    //   //更新shareUrl
    //   this.shareUrl = location.origin + '/readArticleHaibao' + `?shareId=${this.shareId}`
    //   let shareImgUrl = location.origin + "/" + 'readArticleHaibao' + `?shareId=${this.shareId}`
    //   let shareOption = {
    //     title: "蓝思原版分级阅读",
    //     desc: "蓝思原版分级阅读",
    //     link: this.shareUrl,
    //     imgUrl: shareImgUrl,
    //     success: function () {
    //       // that.$toast({
    //       //   message: '分享成功',
    //       //   duration: 1000
    //       // })
    //     },
    //     error: function (res) {
    //       if (res.errMsg.indexOf("function_not_exist") > 0) {
    //         that.$toast({
    //           message: '版本过低请升级',
    //           duration: 1000
    //         })
    //       }
    //     }
    //   }
    //
    //   wx.updateAppMessageShareData(shareOption);
    //   wx.updateTimelineShareData(shareOption);
    // }
  }
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '../stylesheet/common.styl';

.artical-haibao {
  min-height: 100vh;
  box-sizing: border-box;
  color: #fff;
}

.haibao-wrapper {
  min-height: 100vh;
  padding: 34px 34px;
  display: flex;
  flex-direction: column;
  position: relative;
  background: url('../../assets/imgs/haibao-bg.png') no-repeat;
  background-size: 100% 100%;
  background-color: #2B2B2B;
}

.info {
  margin-top: 4px;
  display: flex;
  align-items: center;
  border-radius: 6px;
  color: #fff;

  .user-icon {
    margin-right: 20px;
    width: 62px;
    height: 62px;
    border-radius: 50px;
  }

  .rg {
    flex: 1;

    .nicname {
      margin-bottom: 4px;
      font-size: 17px;
      font-weight: bold;
    }

    .child-id {
      font-size: 11px;
    }
  }
}

.content {
  margin-top: 50px;
  flex: 1;

  p {
    font-size: 22px;
    font-weight: bold;
  }

  .artcle-title {
    text-align: left;
    margin-top: 22px;
    font-size: 16px;
    font-weight: bold;
    line-height: 20px;
    // 解决文字换行重叠
    font-variant: normal !important;
    -webkit-font-variant: normal !important;
    font-variant-ligatures: none !important;
    -webkit-font-variant-ligatures: none !important;
  }
}

/* 我的阅读记录 */
.read-record {
  margin-top: 100px;

  .title {
    text-align: center;
    font-size: 15px;
    margin-bottom: 10px;
  }

  .read-info {
    display: flex;
    justify-content: center;

    .item {
      text-align: right;
      margin: 10px 40px;

      .des {
        font-size: 12px;
      }

      .read-record-num {
        font-size: 28px;
        font-weight: bold;
        color: #30B464;
        font-style: italic;
      }

      .read-record-per {
        font-size: 14px;
      }
    }
  }
}

.logo-wrapper {
  margin-top: 30px;

  .btm-img {
    width: 100%;
  }
}

/* 海报 */
.cover-img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
}

/* 分享指引 */
.share-guide {
  position: relative;

  .share-guide-content {
    position: fixed;
    left: 50%;
    top: 40%;
    transform: translate(-50%, -50%);
    z-index: 1000;
    text-align: center;
  }

  .share-guide-img {
    display: inline-block;
    margin: 0 auto;
    width: 88px;
  }

  .share-guide-text {
    color: #fff;
    font-size: 18px;
    font-weight: bold;
  }

  .share-guide-bg {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.4);
    z-index: 999;
  }
}

/* 加载loading */
.haibao-loading {
  background-color: rgba(0, 0, 0, 0.6);
  position: absolute;
  left: 50%;
  top: 50%;
  padding: 10px 10px;
  transform: translateX(-50%) translateY(-50%);
}

.van-loading__text {
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// app/pages/share/ReadArticleHaibao.vue